import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { signInThunk, initialStateParent } from '../../../store/slices/public/parents.slice';
//UI
import ShowPassword from '../../../components/Inputs/ShowPassword';
import logo from '../../../assets/peef.png';
import UserLogo from '../../../components/Inputs/UserLogo';
import { getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';
import { API_BASE_URL } from '../../../store/constans';
import MainLoader from '../../../components/Loaders/MainLoader';
import { MessageCircle } from "lucide-react"
import { isWithinBusinessHours, Toast } from '../../../resources/utils';

const LoginPublic = () => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const { item, error } = useSelector(state => state.parents);
  const { items } = useSelector(state => state.configurations);
  const isLoading = useSelector(state => state.isLoadingSlice);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [dentroHorario, setDentroHorario] = useState(true)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getConfigsThunk());
    return () => {
      dispatch(initialStateParent());
      dispatch(initialStateConfig())
    }
  }, []);

  useEffect(() => {
    if (items.length > 0) {
      const dentroHorario = isWithinBusinessHours(items[0].soporte_desde, items[0].soporte_hasta);
      if (!dentroHorario) {
        setDentroHorario(dentroHorario);
      }
    }
  }, [items]);

  const submit = (data) => {
    dispatch(signInThunk(data));
  }

  if (Object.keys(item).length !== 0) {
    let userInfo = {
      userName: item.firstName + " " + item.lastName,
      token: item.token,
      isActiveAccount: item.isActiveAccount,
      id: item.ciParent,
      logo: items[0]?.logo
    };

    if (item.changePassword) {
      navigate(`/change_password/${item.ciParent}`)
    } else {
      navigate('/politica_privacidad')
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  }

  return (
    <>
      {isLoading ? (<MainLoader />) : (
        <div
          className={`text-gray-600 flex justify-center items-center 2xl:items-center h-full w-full min-h-screen bg-cover bg-center `}
          style={{ backgroundImage: `url(${API_BASE_URL + items[0]?.background})` }}>

          <div className="absolute top-0 left-0 w-full h-full bg-zinc-800/40 "></div>
          <div className="w-full md:w-[35%] bg-white/80 backdrop-blur-sm shadow-md shadow-gray-800 flex flex-col items-center justify-center rounded-md z-10">
            <div className='flex flex-col gap-2 w-full items-center justify-center p-4'>
              <img className='w-[280px] md:w-[150px]' src={API_BASE_URL + items[0]?.logo} alt="logo" />
              <h1 className="text-[25px] font-semibold mb-0 text-sky-700">¡Bienvenido a matrículas en línea!</h1>
            </div>
            {error &&
              <div className='flex flex-col p-2 gap-1 text-start text-sm font-sans w-[80%] border-red-500 rounded-md border bg-red-200 items-start justify-start'>
                <h1 className="mb-0 font-bold">¡Error!</h1>
                <p className='mb-0'>{error}</p>
              </div>
            }
            <form onSubmit={handleSubmit(submit)} className="w-[75%] mx-auto text-gray-600 my-3 font-sans">
              <div className='flex flex-col'>
                <div className="relative flex flex-col mt-4">
                  <input className={'w-full placeholder-gray-600 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                    type='text'
                    {...register("ciParent", { required: true })}
                    placeholder="Cédula / Pasaporte / RUC"
                  />
                  <UserLogo />
                </div>
                {errors.ciParent && (<span className="error_message">{"Información requerida"}</span>)}
                <div className="relative flex flex-col mt-8">
                  <input className='w-full p-2 rounded-xl placeholder-gray-600 focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'
                    type={isPasswordHidden ? 'password' : 'text'}
                    {...register("password", { required: true })}
                    placeholder="Contraseña"
                  />
                  <ShowPassword
                    isPasswordHidden={isPasswordHidden}
                    setIsPasswordHidden={setIsPasswordHidden}
                  />
                </div>
                {errors.email && (<span className="text-red-600">{"Información requerida"}</span>)}
                <div className='flex gap-2 w-[100%] mt-2 justify-end'>
                  <h1 className="text-[14px] flex gap-2"><Link to={'/forgot_password'}><p className='text-sky-700 hover:text-sky-900 duration-200'>¿Has olvidado tu contraseña?</p> </Link></h1>
                </div>
              </div>
              <div className='flex w-full justify-center h-[35px] mt-10'>
                <button type=" submit" className="btn shadow-lg btn-block bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                  Iniciar sesión
                </button>
              </div>
            </form>
            <div className='flex bg-white/50 p-4 gap-2 w-[100%] my-3 justify-center'>
              <p className='text-gray-500'>¿No tienes cuenta?</p>
              <Link to={'/create_account'}><p className='text-sky-700 hover:text-sky-800 duration-200 cursor-pointer'>Crear cuenta</p> </Link>
            </div>
            <div className='flex flex-col p-4  w-[100%] justify-center items-center text-[12px]'>
              <p className='text-gray-500'>¿Problemas con el proceso?</p>
              <button
                className="flex items-center gap-2 border-green-500 text-green-600 hover:bg-green-50 hover:text-green-700 transition rounded-2xl px-4 py-2 text-sm shadow-sm"
                onClick={() => {
                  if (dentroHorario) {
                    window.open(`https://wa.me/593${items[0]?.numero_soporte}`, '_blank')
                  } else { 
                    Toast.fire({ icon: 'warning', title: `El ahorario de soporte es de ${items[0].soporte_desde +' a '+ items[0].soporte_hasta}` });
                  }

                }}
              >
                Contáctanos
                <MessageCircle className="w-4 h-4" />
              </button>
            </div>
          </div>
          <div className="hidden md:flex md:flex-col md:absolute bg-white/80  md:left-[90%] md:top-[80%] z-10 p-2 rounded-md shadow-md shadow-gray-500">
            <img className='w-[280px] md:w-[100px]' src={logo} alt="logo" />
            <p className='font-semibold text-[13px]'>Proveedor Oficial</p>
          </div>
        </div >
      )}
    </>

  );
}
export default LoginPublic;